import type { GraphQLQuery } from '@affine/graphql';

export type WorkspaceDiscoverySetting = {
  enabled: boolean;
};

export type WorkspaceDiscoverySettingResponse = {
  workspaceDiscoverySetting: WorkspaceDiscoverySetting;
};

export type UpdateWorkspaceDiscoveryResponse = {
  updateWorkspaceDiscovery: WorkspaceDiscoverySetting;
};

// This API is intentionally kept separate from generic workspace updates.
// Discovery is metadata visibility, not workspace or document access.
export const workspaceDiscoverySettingQuery = {
  id: 'workspaceDiscoverySettingQuery',
  op: 'workspaceDiscoverySetting',
  query: `query workspaceDiscoverySettingQuery($workspaceId: ID!) {
  workspaceDiscoverySetting(workspaceId: $workspaceId) {
    enabled
  }
}`,
} satisfies GraphQLQuery;

export const updateWorkspaceDiscoveryMutation = {
  id: 'updateWorkspaceDiscoveryMutation',
  op: 'updateWorkspaceDiscovery',
  query: `mutation updateWorkspaceDiscoveryMutation($input: UpdateWorkspaceDiscoveryInput!) {
  updateWorkspaceDiscovery(input: $input) {
    enabled
  }
}`,
} satisfies GraphQLQuery;

export type WorkspaceDiscoveryGql = <Response>(input: {
  query: GraphQLQuery;
  variables: Record<string, unknown>;
}) => Promise<Response>;
